const types = {
  infoMessage: 'infoMessage',
  warningMessage: 'warningMessage',
};

export default types;
